import { InvoiceDetailViewModel } from '@models/InvoiceDetail';

export const calculateInvoiceGrandTotal = (
  details: InvoiceDetailViewModel[],
  discount: number,
  discountType?: number,
  isTaxExempt?: boolean
): number => {
  const subtotal = details.reduce((acc, cur) => acc + cur.subTotal, 0);

  const taxesTotal = isTaxExempt
    ? 0
    : details
        .map((detail) =>
          detail.invoiceDetailSalesTaxes.reduce(
            (acc, tax) => acc + tax.salesTaxAmount,
            0
          )
        )
        .reduce((acc, cur) => acc + cur, 0);

  let discountAmount = discount;
  if (discountType === 2) {
    // Percentage
    discountAmount = ((subtotal + taxesTotal) * discount) / 100;
  }

  return subtotal + taxesTotal - discountAmount;
};
